<template>
  <SearchContainer
    advancedSearch
    @reset="resetFilters"
    @search="search"
    :disableSearch="!validInterval"
  >
    <template slot="default">
      <div class="row">
        <div class="col-4 col-sm-3">
          <Input
            type="text"
            :field="query.sessionID"
            :label="
              $t('sections.cdrmLandingPage.sessionsWithoutCDRTable.sessionID')
            "
            @input="(e) => onInput('sessionID', e)"
          />
        </div>
        <div class="col-4 col-sm-3">
          <Input
            type="dropdown"
            :field="query.state"
            :label="
              $t('sections.cdrmLandingPage.sessionsWithoutCDRTable.state')
            "
            :items="
              $t(
                'sections.cdrmLandingPage.sessionsWithoutCDRTableSearch.stateOptions'
              )
            "
            @input="(e) => onInput('state', e)"
          />
        </div>
        <div class="col-4 col-sm-4">
          <Input
            type="dropdown"
            :field="query.errorMessage"
            :label="
              $t(
                'sections.cdrmLandingPage.sessionsWithoutCDRTable.errorMessage'
              )
            "
            :items="
              $t(
                'sections.cdrmLandingPage.sessionsWithoutCDRTableSearch.errorMessageOptions'
              )
            "
            :disabled="query.state === 'ERROR'"
            @input="(e) => onInput('errorMessage', e)"
            button
            @onClick="search"
          />
        </div>
      </div>
    </template>
    <template slot="advanced-search">
      <div class="row mb-4">
        <div class="col-auto">
          <div class="search-cards-container row">
            <div class="updated-date-container flex-column col-auto">
              <span class="detail-section-title mb-4">
                {{
                  $t(
                    'sections.cdrmLandingPage.sessionsWithoutCDRTableSearch.lastUpdated'
                  )
                }}
              </span>
              <Input
                type="datepicker"
                :label="
                  $t(
                    'sections.cdrmLandingPage.sessionsWithoutCDRTableSearch.start'
                  )
                "
                :field="query.dateFrom"
                :valid="validStartDate"
                class="mb-3"
                @input="(e) => onInput('dateFrom', e)"
              />
              <Input
                type="datepicker"
                :label="
                  $t(
                    'sections.cdrmLandingPage.sessionsWithoutCDRTableSearch.end'
                  )
                "
                :field="query.dateTo"
                :valid="validEndDate"
                :errorLabel="$t('components.horizontalInput.invalidEndDate')"
                @input="(e) => onInput('dateTo', e)"
              />
              <span class="required-fields">
                {{
                  $t(
                    'sections.cdrmLandingPage.sessionsWithoutCDRTableSearch.intervals'
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'CDRLandingPageSearchOptions',
  components: {
    SearchContainer,
    Input,
  },
  data() {
    return {
      query: {
        state: '',
        errorMessage: '',
        sessionID: '',
        dateFrom: '',
        dateTo: '',
      },
    };
  },
  computed: {
    validEndDate() {
      if (this.query.dateFrom && this.query.dateTo) {
        return new Date(this.query.dateTo).getTime()
          > new Date(this.query.dateFrom).getTime();
      }
      return true;
    },
    validStartDate() {
      return this.validEndDate;
    },
    validInterval() {
      if (this.query.dateFrom && this.query.dateTo) {
        const diff = new Date(this.query.dateTo).getTime()
          - new Date(this.query.dateFrom).getTime();
        return diff > 0 && diff < 7 * 24 * 60 * 60 * 1000;
      }
      return false;
    },
  },
  created() {
    const dateTo = new Date();
    dateTo.setHours(23, 59, 59, 999);
    this.query.dateTo = dateTo;
    const dateFrom = new Date();
    dateFrom.setDate(dateFrom.getDate() - 6);
    dateFrom.setHours(0, 0, 0, 0);
    this.query.dateFrom = dateFrom;
  },
  methods: {
    onInput(field, value) {
      if (field === 'dateFrom' || field === 'dateTo') {
        if (!value) {
          this.query[field] = '';
          return;
        }
        const date = new Date(value);
        if (field === 'dateFrom') {
          date.setHours(0, 0, 0, 0);
        } else {
          date.setHours(23, 59, 59, 999);
        }
        this.query[field] = date;
      } else {
        this.query[field] = value;
      }
    },
    search() {
      if (!this.validInterval) return;
      const query = {};
      Object.keys(this.query).forEach((key) => {
        const value = this.query[key];
        if (value !== '' && value !== null && value !== undefined) {
          query[key] = value;
        }
      });
      this.$emit('onSearch', query);
    },
    resetFilters() {
      const dateTo = new Date();
      dateTo.setHours(23, 59, 59, 999);
      const dateFrom = new Date();
      dateFrom.setDate(dateFrom.getDate() - 6);
      dateFrom.setHours(0, 0, 0, 0);

      this.query = {
        state: '',
        errorMessage: '',
        sessionID: '',
        dateFrom,
        dateTo,
      };

      this.search();
    },
  },
};
</script>
<style lang="scss" scoped>
.advanced-search-container {
  .search-cards-container {
    display: flex;
    --grid-gutter-width: 20px;

    .updated-date-container {
      display: flex;
      --input-label-width: 90px;
    }
  }
}
</style>
